import { render, staticRenderFns } from "./form-password.vue?vue&type=template&id=a4df3252&scoped=true"
import script from "./form-password.vue?vue&type=script&lang=js"
export * from "./form-password.vue?vue&type=script&lang=js"
import style0 from "./form-password.vue?vue&type=style&index=0&id=a4df3252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4df3252",
  null
  
)

export default component.exports